/**
 * 章の大将（敵ヒーロー＝操作キャラ。ADV の敵。式神にはならない）と番人（10面の本城の章ボス。倒すと式神。meta/shikigami.ts）。
 * 指定の無い章はデータどおり（role の rival／boss）。2・5・6・7・9・10章は章ボスの妖が大将になり、番人は別の妖（10章は大嶽丸）
 */
export const CHAPTER_LEADERS: Partial<Record<number, { rival: string; boss: string }>> = {
  2: { rival: 'e020', boss: 'r02' },
  5: { rival: 'e050', boss: 'r05' },
  6: { rival: 'e060', boss: 'r06' },
  7: { rival: 'e070', boss: 'r07' },
  9: { rival: 'e090', boss: 'r09' },
  10: { rival: 'e100', boss: 'r10' },
};
